import { createControlComponent } from '@react-leaflet/core';
import { Control } from 'leaflet';
export var ScaleControl = createControlComponent(function createScaleControl(props) {
  return new Control.Scale(props);
});